import { useEffect, useState } from 'react';
import { useLabelService } from 'hooks/api/agents/label';
import { useLabelAssignmentService } from 'hooks/api/agents/label-assignment';

export const useResourceLabelsByKind = (kind) => {
  const { fetchLabels } = useLabelService();
  const { fetchLabelAssignments } = useLabelAssignmentService();

  const [labels_by_resource, setLabelsByResource] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!kind) return;
    let cancelled = false;
    setLoading(true);

    Promise.all([
      fetchLabels({ query_string: 'population=200' }),
      fetchLabelAssignments({ query_string: `resource.kind=${kind}&population=500` })
    ])
      .then(([{ labels }, { label_assignments }]) => {
        if (cancelled) return;

        const labels_by_id = new Map((labels || []).map((label) => [label.id, label]));
        const grouped = {};

        (label_assignments || []).forEach((assignment) => {
          const label = labels_by_id.get(assignment.label_id);
          const resource_id = assignment.resource?.id;
          if (!label || resource_id == null) return;

          grouped[resource_id] = [...(grouped[resource_id] || []), label];
        });

        setLabelsByResource(grouped);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind]);

  return { labels_by_resource, loading };
};

export default useResourceLabelsByKind;
